// For Keyboard layout, we need the sharp/flat first
// Lucky us, sorting by string length do the trick
export function keyboardSorting(a: string, b: string): number {
    return b.length - a.length;
}
